export const ConsumeColumns = [
  {
    accessor: 'createDateTime',
    header: 'تاریخ',
    Header: 'تاریخ',
    key: 'createDateTime',
  },
  {
    accessor: 'orderCode',
    header: 'جزئیات مصرف',
    Header: 'جزئیات مصرف',
    key: 'orderCode',
  },
  {
    accessor: 'amount',
    header: 'مبلغ',
    Header: "مبلغ",
    key: 'amount',
  },
]

